<template>
  <div>
    <Navbar
      v-if="!isDesktop"
      @desktopNavigate="navigateBackToMode"
      :current_mode="'inside'"
    />

    <ChooseTable
      @selectTable="onTableSelected"
      @select="onTableSelectionConfirmed"
      :sections="cafe.sections"
      :orders="[]"
      @close="backToOrders"
    />
  </div>
</template>

<script>
import ChooseTable from "@/components/modals/ChooseTable.vue";
import Navbar from "@/components/Navbar.vue";

export default {
  data() {
    return {};
  },
  methods: {
    backToOrders() {
      this.$router.push("/orders");
    },
    navigateBackToMode(mode) {
      this.$router.push({
        name: "orders",
        query: {
          m: mode,
        },
      });
    },
    onTableSelected(section, table) {
      const type = this.$route.name;

      if (type == "create_order_choose") {
        this.$router.push({
          name: "create_order",
          params: {
            section,
            table,
          },
        });
      }
    },
    onTableSelectionConfirmed(section, table) {
      const type = this.$route.name;

      if (type == "move_action") {
        this.$store
          .dispatch("queue/moveOrder", {
            order_id: this.$route.params.order_id,
            section,
            table,
          })
          .then((ok) => {
            this.backToOrders();
          });
      }

      if (type == 'to_inside') {
        this.$store
          .dispatch("preorder/convertToInside", {
            preorder_id: this.$route.params.preorder_id,
            section,
            table,
          })
          .then((ok) => {
            this.backToOrders();
          });
      }
    }
  },
  computed: {
    isDesktop() {
      return window.innerWidth > 768;
    },
    cafe() {
      return this.$store.state.cafe;
    },
    orders() {
      return this.$store.state.queue.orders;
    },
  },
  components: {
    Navbar,
    ChooseTable,
  },
};
</script>
